var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"month-selector",staticStyle:{"width":"100%"}},[_c('button',{on:{"click":_vm.previousMonth}},[_vm._v("<")]),_c('span',{staticClass:"month"},[_vm._v(_vm._s(_vm.selectedMonth.toLocaleString('default', { month: 'long', year: 'numeric' })))]),_c('button',{on:{"click":_vm.nextMonth}},[_vm._v(">")])])
}
var staticRenderFns = []

export { render, staticRenderFns }